import PropTypes from 'prop-types';

const EMBED_BASE = 'https://www.youtube.com/embed/';

export default function YoutubeColumns({ videos }) {
  return (
    <div className="youtube-columns">
      {videos.map((video) => (
        <div className="youtube-column" key={video.id}>
          <div className="youtube-column__frame">
            <iframe
              src={`${EMBED_BASE}${video.id}`}
              title={video.title || 'AMC video'}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              loading="lazy"
            />
          </div>
          {video.title ? (
            <p className="youtube-column__caption">{video.title}</p>
          ) : null}
        </div>
      ))}
    </div>
  );
}

YoutubeColumns.propTypes = {
  videos: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string
    })
  )
};

YoutubeColumns.defaultProps = {
  videos: []
};
